import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css']
})
export class SearchInputComponent implements OnInit {

  @Input() initialSearch:string;

  @Output() search = new EventEmitter<string>();
  @Output() reset = new EventEmitter<void>();

  private _searchString:string;

  constructor() { }

  ngOnInit() {
    if (this.initialSearch) {
      this._searchString = this.initialSearch;
    }
  }

  public get searchPhrase() {
        return this._searchString;
    }

  public set searchPhrase(v:string) {
        this._searchString = v;
    }
    
    public enterKeySearch(event) {
        // enter key is 13
        if (event.charCode === 13) {
            this.doSearch();
        }
    }
    
    public doSearch() {
      this.search.emit(this._searchString);
    }
    
    public resetSearch() {
      this._searchString = "";
      this.reset.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/search-input/search-input.component.ts